/**
 * A solicitação hidrata o formulário antes de existir pessoa: a simulação é que
 * anexa a pessoa reaproveitada (ADR-0012), já com endereço e conta. A chave muda
 * e o formulário hidrata de novo. O rascunho local continua por cima do servidor.
 */
export function hydrationStamp(
  applicationKey: string,
  personKey: string | undefined,
) {
  return `${applicationKey}:${personKey ?? ''}`
}

export function shouldRehydrate(current: string | null, next: string) {
  return current !== next
}
